import * as React from "react";
import CreatableSelect, { Option, Options } from 'react-select';
import apifetch from "utils/apifetch";
import extractErrorMessage from "utils/extractErrorMessage";
import Product from "../../interfaces/Product";


interface Props {
    productId?: number;
    uniqueAutoId?: number;
    onItemSelect?: (value: string) => void;
    onInputChange?: (value: string) => void;
    price?: number;
    tabIndex?: number;
}

interface State {
    productId?: number;
    data: Product;
    prices?: Options;
    selectedPrice: Option;
    oldVal: string;
}

export default class PriceSelect extends React.Component<Props, State> {
    private selectRef: React.RefObject<any>;

    constructor(props: Props) {
        super(props);

        this.state = {
            productId: props.productId,
            data: {} as any,
            prices: [] as Options,
            selectedPrice: props.price !== undefined && props.price !== 0
                ? { value: props.price, label: props.price.toString() } as Option
                : {} as Option,
            oldVal: ""
        };

        this.selectRef = React.createRef();

        this.handlePriceChanged = this.handlePriceChanged.bind(this);
        this.handleInputChanged = this.handleInputChanged.bind(this);
    }

    public clearValue() {
        this.setState({
            selectedPrice: {} as Option,
            oldVal: ""
        });
    }

    public focus() {
        if (this.selectRef.current) {
            this.selectRef.current.focus();
        }
    }

    public render() {
        return <div>
            <CreatableSelect
                ref={this.selectRef}
                value={this.state.selectedPrice}
                options={this.state.prices}
                noResultsText=""
                clearable={true}
                addLabelText=""
                onBlurResetsInput={false}
                onCloseResetsInput={false}
                onChange={this.handlePriceChanged}
                onInputChange={this.handleInputChanged}
                tabIndex={this.props.tabIndex ? String(this.props.tabIndex) : undefined}
                backspaceRemoves={true}
                deleteRemoves={true}
                onFocus={this.handleFocus}
            />
        </div>;
    }

    private handleFocus = () => {
        // Select all text in the input when focused
        setTimeout(() => {
            if (this.selectRef.current) {
                const input = this.selectRef.current.input as HTMLInputElement;
                if (input) {
                    input.select();
                }
            }
        }, 0);
    };

    public async componentDidMount() {

        if (this.props.productId !== undefined && this.props.productId >= 0) {
            let response = await apifetch("products/" + this.props.productId, undefined, true);
            if (response.ok) {
                let data = await response.json() as Product;
                let productPrices = [];
                if (data.sectionId !== null) {
                    let listPriceObj = data.listPrice;
                    productPrices.push({ name: "Price1: $", value: listPriceObj });
                    let ourListPriceObj = data.ourListPrice;
                    productPrices.push({ name: "Price2: $", value: ourListPriceObj });
                    let marketCostObj = data.marketCost;
                    productPrices.push({ name: "Price3: $", value: marketCostObj });
                    let price4Obj = data.price4;
                    productPrices.push({ name: "Price4: $", value: price4Obj });
                }

                this.setState({
                    data: data,
                    prices: productPrices.map(p => ({ value: p.value, label: p !== undefined ? p.name + p.value : "" }))
                });
            } else {
                console.error(await extractErrorMessage(response));
            }
        }
    }

    public async componentDidUpdate(prevProps: { productId: number }) {

        if (this.props.productId !== undefined && prevProps.productId !== this.props.productId) {

            let response = await apifetch("products/" + this.props.productId, undefined, true);
            if (response.ok) {
                let data = await response.json() as Product;

                let productPrices = [];
                if (data.sectionId !== null) {
                    let listPriceObj = data.listPrice;
                    productPrices.push({ name: "Price1: $", value: listPriceObj });
                    let ourListPriceObj = data.ourListPrice;
                    productPrices.push({ name: "Price2: $", value: ourListPriceObj });
                    let marketCostObj = data.marketCost;
                    productPrices.push({ name: "Price3: $", value: marketCostObj });
                    let price4Obj = data.price4;
                    productPrices.push({ name: "Price4: $", value: price4Obj });
                }

                this.setState({
                    data: data,
                    prices: productPrices.map(p => ({ value: p.value, label: p !== undefined ? p.name + p.value : "" }))
                });
            } else {
                console.error(await extractErrorMessage(response));
            }
        }
    }

    handlePriceChanged(newValue: Option | Options | null) {

        this.setState({
            selectedPrice: newValue as Option,
        });

        if (this.props.onItemSelect !== undefined) {
            if (newValue !== null) {
                let selectedVal = newValue as Option;
                this.props.onItemSelect!(selectedVal !== null && selectedVal.label !== undefined ? selectedVal.value + "" : "");
            } else {
                this.props.onItemSelect!("0");
            }
        }
    }

    //handleInputChanged(newValue: string) {
    //    if (newValue !== "") {
    //        if (this.props.onItemSelect !== undefined) {
    //            this.props.onInputChange!(newValue);
    //        }
    //    } else {
    //        this.props.onInputChange!("0");
    //    }
    //}

    handleInputChanged(newValue: string) {
        // Only allow numbers and decimal point
        const sanitizedValue = newValue.replace(/[^0-9.]/g, '');
        // Prevent multiple decimal points
        const parts = sanitizedValue.split('.');
        const finalValue = parts.length > 2 ? parts[0] + '.' + parts.slice(1).join('') : sanitizedValue;

        if (finalValue !== "") {
            if (this.props.onInputChange !== undefined) {
                this.props.onInputChange!(finalValue);
            }
        } else {
            if (this.props.onInputChange !== undefined) {
                this.props.onInputChange!("0");
            }
        }
        return finalValue;
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/common/PriceSelect.tsx